import {Injectable} from '@angular/core';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {TranslocoService} from '@ngneat/transloco';
import {RequestService} from "./request.service";
import {AuthenticationService} from "./authentication.service";
import {RequestStatus, RequestFilter, Organiser, Request, TOAST_STATE} from "@model";
import {NewOrganiserModalComponent} from "@components";
import {ToastService} from './toast.service';
import {LoaderService} from './loader.service';

@Injectable({
  providedIn: 'root'
})
export class OrganiserRequestService {
  constructor(
    private requestService: RequestService,
    private authenticationService: AuthenticationService,
    private modalService: NgbModal,
    private translocoService: TranslocoService,
    private toastService: ToastService,
    private loaderService: LoaderService
  ) {
  }

  openOrganiserRequestModal(): void {
    const userId = this.authenticationService.jwtResponse.value?.id;

    this.requestService.fetchRequestsCount(new RequestFilter(RequestStatus.ON_HOLD, userId))
      .subscribe((count: number) => {
        let organiserRequestSent: boolean = (count ?? 0) > 0;

        const modalRef: NgbModalRef = this.modalService.open(NewOrganiserModalComponent, {
          centered: true,
          windowClass: 'new-organiser-modal'
        });
        modalRef.componentInstance.title = this.translocoService.translate("request.header.title");
        modalRef.componentInstance.requestSent = organiserRequestSent;

        modalRef.result.then((organiser: Organiser): void => {

          this.loaderService.startLoading()
          this.requestService.sendOrganiserRequest(Request.createOrganiserRequest(organiser), () => {
            this.loaderService.dismissLoading()
            this.toastService.showToast(TOAST_STATE.success,
              this.translocoService.translate("newOrganiser.request.sent.success"));
          }, (errorCode?: number) => {
            this.loaderService.dismissLoading()
            if (errorCode === RequestService.EXISTING_ORGANISER_REQUEST_ON_HOLD) {
              this.toastService.showToast(TOAST_STATE.danger,
                this.translocoService.translate("newOrganiser.request.alreadySent"));
            } else {
              this.toastService.showToast(TOAST_STATE.danger,
                this.translocoService.translate("newOrganiser.request.alreadySent.error"));
            }
          });
        }, (_: any): void => {
         /// on modal dismiss, ignore
        });
      });
  }
}
